import { useQuery } from '@apollo/client/react'
import {
  OrgTicketsDocument,
  type OrgTicketsQuery,
} from '@/graphql/generated/graphql'

export type OrgTicketListItem = OrgTicketsQuery['orgTickets']['items'][number]

export interface UseOrgTicketsArgs {
  page: number
  perPage: number
  state?: string | null
  type?: string | null
  businessId?: string | null
  q?: string | null
  /** Si es `false`, no dispara la query (evita FORBIDDEN sin alcance). */
  enabled?: boolean
}

/** Listado de tickets de soporte de la organización del propietario. */
export function useOrgTickets({
  page,
  perPage,
  state,
  type,
  businessId,
  q,
  enabled = true,
}: UseOrgTicketsArgs) {
  const { data, loading, error, refetch } = useQuery(OrgTicketsDocument, {
    skip: !enabled,
    variables: {
      filters: {
        page,
        perPage,
        state: state || null,
        type: type || null,
        businessId: businessId || null,
        q: q?.trim() ? q.trim() : null,
      },
    },
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  })

  return {
    tickets: data?.orgTickets.items ?? [],
    totalItems: data?.orgTickets.total ?? 0,
    loading,
    error,
    refetch,
  }
}
